module.exports = __webpack_public_path__ + "img/terracenew_box01.ee90d540.jpg";